import { Component, OnInit } from '@angular/core';
import { CategoryQuizService } from '../../services/category-quiz.service';
import { delay, pipe, tap } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { LanguageServiceX } from '../../services/language.service';

@Component({
  selector: 'app-category-adder',
  templateUrl: './category-adder.component.html',
  styleUrls: ['./category-adder.component.scss'],
})
export class CategoryAdderComponent implements OnInit {
  categoryList: any[];
  categoryData = [];

  constructor(
    private _categoryquiz: CategoryQuizService,
    private language: LanguageServiceX,
    private notification: NzNotificationService
  ) {}

  ngOnInit(): void {
    this._categoryquiz.getCategories().subscribe((data) => {
      // this.categoryList = data;
      console.log(data);
      this.categoryList = data.map((treward: any) => {
        return {
          nom: treward.nom,
          isEditing: false,
          id: treward.categoriequizid,
        };
      });
      console.log(
        'les categories disponible : ',
        this.categoryList,
        this.isAdding
      );
    });
  }

  newAddedValue: string = 'Nouvelle categorie de quiz';
  isAdding: boolean = false;

  toggleAdding() {
    this.isAdding = true;
  }

  addRewardType() {
    try {
      if (this.newAddedValue?.length > 3) {
        this._categoryquiz
          .addCategory(this.newAddedValue, 'Fantastique categorie')
          .subscribe((data) => {
            this.categoryList.push({
              isEditing: false,
              nom: data.nom,
              id: data.categoriequizid,
            });
            this.isAdding = false;
            this.newAddedValue = '';
          });
      }
    } catch (error) {
      console.log('Les erreurs :', error);
    }
  }

  cancelAdding() {
    this.isAdding = false;
    this.newAddedValue = '';
  }

  deleteCategory(id: number) {
    this._categoryquiz
      .deleteCategory(id)
      .pipe(
        tap({
          next: (data) => {
            this.notification.success(
              'Categorie supprimée avec succés',
              'Consultez la liste'
            );
          },
          error: (err) => {
            this.notification.error('Erreur survenue', 'Consultez la liste');
          },
        })
      )
      .subscribe((data) => {
        console.log('categorie supprimer avec succes...');
      });

    this.categoryList = this.categoryList.filter(
      (typereward) => typereward.id != id
    );
  }

  editCategory(id: number) {
    this.categoryList[id].isEditing = !this.categoryList[id].isEditing;
  }

  updateTypeReward(newData: any, id: number, typeId: number) {
    this.categoryList[id].isEditing = !this.categoryList[id].isEditing;
    this._categoryquiz
      .updateCategory(typeId, newData)
      .pipe(
        tap({
          next: (data) => {
            this.notification.success(
              'Categorie modifié avec succés',
              'Consultez la liste'
            );
          },
          error: (err) => {
            this.notification.error('Erreur survenue', 'Consultez la liste');
          },
        })
      )
      .subscribe((data) => {
        console.log('Mise a jour de la categorie effectuer avec succés...');
      });
  }
}
